import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBKImXYwzSZLHqiOqW0yIMbfVt77-aVIOQ",
  authDomain: "neosap-a323a.firebaseapp.com",
  projectId: "neosap-a323a",
  storageBucket: "neosap-a323a.firebasestorage.app",
  messagingSenderId: "200359984488",
  appId: "1:200359984488:web:a602c87827d25d89fc2add",
  measurementId: "G-VNQ1Q3TZWM",
};

const app = initializeApp(firebaseConfig);

export const db             = initializeFirestore(app, { localCache: persistentLocalCache() });
export const auth           = getAuth(app);
export const storage        = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
